import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type MinusIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const MinusIcon: React.FC<MinusIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="minus">
        <path id="Mark" d="M4.5 8H12.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>

  </IconSpan>
);

